// extracted by mini-css-extract-plugin
module.exports = {"blockInputSearch":"input-search_blockInputSearch__zxcEL","input":"input-search_input__23e1E"};